export default __webpack_public_path__ + "static/media/345.78cbb137.jpg";